import { Field } from 'components/DocumentDetail/types'
import FormInput from 'components/ui/FormInput'
import useConfidenceColor from 'hooks/useConfidenceColor'
import { useHighlightContext } from 'hooks/useHighlightContext'

const CHECKBOX_STATE_LABEL = {
  checked: 'チェックあり',
  unchecked: 'チェックなし',
} as const

const CHECKBOX_PROPS = {
  stateLabel: CHECKBOX_STATE_LABEL,
  labelPlacement: 'start',
  onClick: (e) => e.target.tagName !== 'INPUT' && e.preventDefault(),
} as const

type EditFieldProps = Field & {
  onFocus?: () => void
  hlKey?: string
}

function EditField({
  name,
  type,
  rules,
  confidence,
  defaultValue,
  compProps,
  onFocus,
  hlKey,
  testid,
}: EditFieldProps) {
  const confidenceColor = useConfidenceColor(confidence)
  const { update: updateHL } = useHighlightContext()
  const isCheckbox = type === 'checkbox'

  // label handling for checkbox type
  const props = isCheckbox
    ? {
        ...compProps,
        ...CHECKBOX_PROPS,
      }
    : compProps

  return (
    <FormInput
      name={name}
      rules={rules}
      type={type!}
      defaultValue={defaultValue}
      onFocus={() => (onFocus ? onFocus() : updateHL(hlKey || name))}
      onBlur={() => updateHL(null)}
      testid={testid}
      {...props}
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: confidenceColor,
        },
      }}
    />
  )
}

export default EditField
